// extracted by mini-css-extract-plugin
export default {"searchPage":"SearchPage_searchPage__vJkdD","leftSearch":"SearchPage_leftSearch__T63zV","rightSearch":"SearchPage_rightSearch__bVuUQ"};